import { useContext } from 'react';
import { AuthContext } from './AuthProvider';

// Configures Amplify from SSO_CONFIG_JSON and points it at whichever Cognito
// region is currently active. See libs/shared/core/src/auth.
export { initAmplifyAuth } from '@/auth';

export const useAuthContext = () => useContext(AuthContext);

export * from './AuthProvider';
